import { useAddAuditLogForProductAndServiceApplicationMutation } from "../../app/services/productAndService/productAndServiceApi";
import { getAuthProps } from "../../lib/authenticationLibrary";

export const useAddAuditLogForSGBPApplcation = () => {
    const [addAuditLogForProductAndService, { isSuccess, isLoading, data }] = useAddAuditLogForProductAndServiceApplicationMutation();
    const addAuditLog = async ({ SGBPSApplicationId, AuditLogDescription, TriggredTimeStatusId }) => {
        const authData = getAuthProps();

        const req = {
            SGBPSApplicationId: SGBPSApplicationId || 0,
            AuditLogDescription: AuditLogDescription || "",
            byWho: authData?.userName || "",
            TriggredTimeStatusId: TriggredTimeStatusId || null,
        };

        console.log("addAuditLogForRejectSGBPApplcation req", req);

        await addAuditLogForProductAndService(req);
    };

    return {
        addAuditLog,

    };
};